<!-- Card APRESENTACIONAL do contrato ativo (somente leitura, exceto o dropdown
     opcional de "Mes de referencia" na visao do contador). Com `plano`, renderiza
     apenas o grid (sem moldura/header) para encaixar dentro de outro card. -->
<ng-container *ngIf="contrato">
  <div [class.form-card]="!plano">
    <div class="card-header" *ngIf="!plano">
      <div class="card-header-icon">
        <i class="pi pi-file-edit"></i>
      </div>
      <span class="card-header-title">{{ tituloKey | translate }}</span>
      <!-- Acao de cancelar (visao do contador): so aparece quando habilitada e o
           contrato ainda e cancelavel (ATIVO/PENDENTE). O dialog de confirmacao +
           data vive no componente pai (o card e apresentacional). -->
      <button *ngIf="mostrarCancelar && cancelavel"
        pButton
        type="button"
        icon="pi pi-times-circle"
        severity="danger"
        class="p-button-outlined p-button-danger btn-sm btn-cancelar-contrato"
        style="margin-left: auto; gap: 0.35rem"
        [label]="'contador_operar.despesa_acessoria.contrato.cancelar_botao' | translate"
        (click)="cancelar.emit()">
      </button>
    </div>
    <div [class.card-content]="!plano">
      <div class="info-grid">
      <!-- Nome (rotulo configuravel via nomeLabelKey: cliente ou contador) -->
      <div class="info-item">
        <span class="info-label">{{ nomeLabelKey | translate }}</span>
        <span class="info-value">{{ contrato.nome }}</span>
      </div>

      <!-- Status: ATIVO (ou ausente) => tag verde; demais => tag neutra -->
      <div class="info-item">
        <span class="info-label">{{ 'contador_operar.despesa_acessoria.contrato.status' | translate }}</span>
        <span class="info-value">
          <p-tag *ngIf="statusAtivo"
            severity="success"
            [value]="'contador_operar.despesa_acessoria.contrato.status_ativo' | translate">
          </p-tag>
          <p-tag *ngIf="!statusAtivo"
            styleClass="tag-status-neutra"
            [value]="statusLabel()">
          </p-tag>
        </span>
      </div>

      <!-- Valor mensal -->
      <div class="info-item">
        <span class="info-label">
          {{ 'contador_operar.despesa_acessoria.contrato.valor_mensal' | translate }}
          <i *ngIf="valorMensalEditavel" class="pi pi-info-circle info-ajuda"
            [pTooltip]="'contador_operar.despesa_acessoria.contrato.editar_propagacao_ajuda' | translate"
            tooltipPosition="top"></i>
        </span>
        <span class="info-value">
          <span *ngIf="valorMensalEditavel; else valorMensalLeitura" class="contrato-campo-editavel">
            <span class="contrato-valor-input">
              <span class="contrato-valor-simbolo">{{ moedaSimbolo }}</span>
              <input type="text" pInputText
                inputmode="numeric"
                [value]="valorMensalStr"
                [disabled]="valorMensalSalvando"
                (input)="formatarValorMensal($event)"
                (blur)="reverterValorMensal()"
                (keydown.enter)="confirmarValorMensal()" />
            </span>
            <button pButton type="button" icon="pi pi-check"
              class="p-button-rounded p-button-text p-button-sm contrato-confirmar-btn"
              [pTooltip]="'contador_operar.despesa_acessoria.contrato.confirmar_edicao' | translate"
              tooltipPosition="top"
              [disabled]="valorMensalSalvando"
              (mousedown)="$event.preventDefault()"
              (click)="confirmarValorMensal()">
            </button>
          </span>
          <ng-template #valorMensalLeitura>
            {{ contrato.valorMensal | moedaSimbolo: moedaConfig.symbol : moedaConfig.digits : moedaConfig.locale }}
            <small *ngIf="contrato.moedaNome" class="info-moeda">({{ contrato.moedaNome }})</small>
          </ng-template>
        </span>
      </div>

      <!-- Percentual de desconto -->
      <div class="info-item">
        <span class="info-label">{{ 'contador_operar.despesa_acessoria.contrato.percentual_desconto' | translate }}</span>
        <span class="info-value">{{ contrato.percentualDesconto }}%</span>
      </div>

      <!-- Dia de cobranca -->
      <div class="info-item">
        <span class="info-label">
          {{ 'contador_operar.despesa_acessoria.contrato.dia_cobranca' | translate }}
          <i *ngIf="diaCobrancaEditavel" class="pi pi-info-circle info-ajuda"
            [pTooltip]="'contador_operar.despesa_acessoria.contrato.editar_propagacao_ajuda' | translate"
            tooltipPosition="top"></i>
        </span>
        <span class="info-value">
          <span *ngIf="diaCobrancaEditavel; else diaCobrancaLeitura" class="contrato-campo-editavel">
            <input type="text" pInputText
              inputmode="numeric"
              class="contrato-dia-input"
              [value]="diaCobrancaEdit ?? ''"
              [disabled]="diaCobrancaSalvando"
              (input)="formatarDia($event)"
              (blur)="reverterDiaCobranca()"
              (keydown.enter)="confirmarDiaCobranca()" />
            <button pButton type="button" icon="pi pi-check"
              class="p-button-rounded p-button-text p-button-sm contrato-confirmar-btn"
              [pTooltip]="'contador_operar.despesa_acessoria.contrato.confirmar_edicao' | translate"
              tooltipPosition="top"
              [disabled]="diaCobrancaSalvando"
              (mousedown)="$event.preventDefault()"
              (click)="confirmarDiaCobranca()">
            </button>
          </span>
          <ng-template #diaCobrancaLeitura>{{ contrato.diaCobranca || '-' }}</ng-template>
        </span>
      </div>

      <!-- Parcelas por mes -->
      <div class="info-item">
        <span class="info-label">
          {{ 'contador_operar.despesa_acessoria.contrato.parcelas_por_mes' | translate }}
          <i *ngIf="parcelasPorMesEditavel" class="pi pi-info-circle info-ajuda"
            [pTooltip]="'contador_operar.despesa_acessoria.contrato.parcelas_por_mes_ajuda' | translate"
            tooltipPosition="top"></i>
        </span>
        <span class="info-value">
          <span *ngIf="parcelasPorMesEditavel; else parcelasPorMesLeitura" class="contrato-campo-editavel">
            <input type="text" pInputText
              inputmode="numeric"
              class="contrato-dia-input"
              [value]="parcelasPorMesEdit ?? ''"
              [disabled]="parcelasPorMesSalvando"
              (input)="formatarParcelasPorMes($event)"
              (blur)="reverterParcelasPorMes()"
              (keydown.enter)="confirmarParcelasPorMes()" />
            <button pButton type="button" icon="pi pi-check"
              class="p-button-rounded p-button-text p-button-sm contrato-confirmar-btn"
              [pTooltip]="'contador_operar.despesa_acessoria.contrato.confirmar_edicao' | translate"
              tooltipPosition="top"
              [disabled]="parcelasPorMesSalvando"
              (mousedown)="$event.preventDefault()"
              (click)="confirmarParcelasPorMes()">
            </button>
          </span>
          <ng-template #parcelasPorMesLeitura>{{ contrato.parcelasPorMes || '-' }}</ng-template>
        </span>
      </div>

      <!-- Data de criacao do contrato -->
      <div class="info-item">
        <span class="info-label">{{ 'contador_operar.despesa_acessoria.contrato.criado_em' | translate }}</span>
        <span class="info-value">
          {{ contrato.criadoEm ? (contrato.criadoEm | date: 'dd/MM/yyyy') : '-' }}
        </span>
      </div>

      <!-- Vencimento -->
      <div class="info-item">
        <span class="info-label">{{ 'contador_operar.despesa_acessoria.contrato.vencimento' | translate }}</span>
        <span class="info-value">
          {{ contrato.dataVencimento ? (contrato.dataVencimento | date: 'dd/MM/yyyy') : '-' }}
        </span>
      </div>

      <!-- Mes de referencia: dropdown editavel (contador) OU texto (cliente) -->
      <div class="info-item">
        <span class="info-label">
          {{ 'contador_operar.despesa_acessoria.contrato.mes_referencia' | translate }}
          <i class="pi pi-info-circle info-ajuda"
            [pTooltip]="'contador_operar.despesa_acessoria.contrato.mes_referencia_ajuda' | translate"
            tooltipPosition="top"></i>
        </span>
        <span class="info-value">
          <p-dropdown *ngIf="mesReferenciaEditavel; else mesReferenciaLeitura"
            [options]="mesReferenciaOptions"
            optionLabel="label"
            optionValue="value"
            [ngModel]="mesReferenciaValor"
            (ngModelChange)="mesReferenciaValorChange.emit($event)"
            [disabled]="mesReferenciaSalvando"
            appendTo="body"
            styleClass="mes-referencia-dropdown"
            (onChange)="mesReferenciaChange.emit($event.value)">
          </p-dropdown>
          <ng-template #mesReferenciaLeitura>{{ mesReferenciaLabelSelecionada }}</ng-template>
        </span>
      </div>

      <!-- Autonomia (somente leitura). Concedida => tag verde; nao concedida => tag neutra.
           Ocultada quando `mostrarAutonomia` for false (ex.: cliente usa o switch). -->
      <div class="info-item" *ngIf="mostrarAutonomia">
        <span class="info-label">
          {{ 'contador_operar.despesa_acessoria.contrato.autonomia' | translate }}
          <i class="pi pi-info-circle info-ajuda"
            [pTooltip]="'contador_operar.despesa_acessoria.contrato.autonomia_ajuda' | translate"
            tooltipPosition="top"
            [attr.aria-label]="'contador_operar.despesa_acessoria.contrato.autonomia_ajuda' | translate"></i>
        </span>
        <span class="info-value">
          <p-tag *ngIf="contrato.autonomiaContador"
            severity="success"
            [value]="'contador_operar.despesa_acessoria.contrato.autonomia_concedida' | translate">
          </p-tag>
          <p-tag *ngIf="!contrato.autonomiaContador"
            styleClass="tag-autonomia-neutra"
            [value]="'contador_operar.despesa_acessoria.contrato.autonomia_nao_concedida' | translate">
          </p-tag>
        </span>
      </div>
    </div>
  </div>
  </div>
</ng-container>
